import React from 'react';

import Link from '@material-ui/core/Link';

export default function TermsOfUse(props)
{
  return (
    <Link color="inherit" {...props} href="https://www.uts-navi.com/terms/navioption.html">
      利用規約
    </Link>
  );
}